import {ChangeDetectionStrategy, Component} from "@angular/core";
import {TranslateModule} from '@ngx-translate/core';
import {HtmlPipe} from '../../utils/html.pipe';
import {IconComponent} from "../../ui-elements/icon/icon.component";
import {IconButtonComponent} from "../../buttons/icon-button/icon-button.component";
import {LinkComponent} from "../../buttons/link/link.component";
import {AbstractMessage} from "./abstract-message";

@Component({
    selector: "woa-footer-message",
    templateUrl: "./message.component.html",
    styleUrls: ["./message.component.scss", "./footer-message.component.scss"],
    imports: [
        HtmlPipe,
        IconButtonComponent,
        IconComponent,
        LinkComponent,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterMessageComponent extends AbstractMessage {
}
